import Api from './Api';
import Csrf from "./Csrf";

export default {
    async getProgrammeStudents(programme_id, level_id, session_id, page) {
        await Csrf.getCookie();
        return Api.get('/students/programme-students/' + programme_id + '/' + level_id + '/' + session_id + '?page=' + page);
    },

    async getStudentsRegistration(programme_id, session_id, level_id, per_page, page) {
        await Csrf.getCookie();
        return Api.get('/students/students-registration-list/' + programme_id + '/' + session_id + '/' + level_id + '/' + per_page + '?page=' + page);
    },

    async getStudentsRegistrationSubmission(programme_id, session_id, level_id, page, per_page) {
        await Csrf.getCookie();
        return Api.get('/students/students-registration-submission-list/' + programme_id + '/' + session_id + '/' + level_id + '/' + per_page + '?page=' + page);
    },
    async getDepartmentalCourseRegistrations(programme_id, session_id, level_id, page) {
        await Csrf.getCookie();
        return Api.get('/students/departmental-course-registrations/' + programme_id + '/' + session_id + '/' + level_id + '?page=' + page);
    },

    async getStudentsCourseEnrollment(course_id, session_id, level_id, page, per_page) {
        await Csrf.getCookie();
        return Api.get('/students/students-course-enrollment-list/' + course_id + '/' + session_id + '/' + level_id + '/' + per_page + '?page=' + page);
    },

    async getMyResultsSpreadSheet(student_id) {
        await Csrf.getCookie();
        return Api.get('/students/student-results-spreadsheet/' + student_id);
    },

    async getCourseRegistrationsList(student_id) {
        await Csrf.getCookie();
        return Api.get('/student/course-registrations-list/' + student_id);
    },

    async getSessionalCourseRegistrationsList(student_id, session_id) {
        await Csrf.getCookie();
        return Api.get('/student/session-course-registrations-list/' + student_id + "/" + session_id);
    },

    async checkRegistrationPaymentStatus(student_id, session_id, semester_id) {
        await Csrf.getCookie();
        return Api.get('/students/registration-payment/status/' + student_id + '/' + session_id + '/' + semester_id);
    },

    async checkPaymentStatus(student_id, session_id) {
        await Csrf.getCookie();
        return Api.get('/students/payment/status/' + student_id + '/' + session_id);
    },

    async updateCourseRegistration(student_id, courses) {
        await Csrf.getCookie();
        return Api.patch('/students/' + student_id + '/course-registration/update', courses);
    },

    async viewCourseForm(student_id, session_id) {
        await Csrf.getCookie();
        return Api.get('/students/' + student_id + '/course-registration/session/' + session_id + '/course-form');
    },

    async previewCourseForm(student_id, session_id, semester_id) {
        await Csrf.getCookie();
        return Api.get('/students/' + student_id + '/course-registration/session/' + session_id + '/'+ semester_id +'/course-form/preview');
    },
    async getStudentsInFaculty(faculty_id) {
        await Csrf.getCookie();
        return Api.get('/allStudents/faculty/' + faculty_id);
    },
    async updateMilitaryStatus(form_data) {
        await Csrf.getCookie();
        return Api.patch('/student/military-status', form_data);
    },

    //------------------ APIs for downloading printouts -----------

    async downloadPrintout(url) {
        // await Csrf.getCookie();
        return Api.get(url, { responseType: 'blob' });
    },

    async getStudentCountsBySessionID(session_id) {
        await Csrf.getCookie();
        return Api.get('/count-total-student/' + session_id);
    },

    async getMyCurrentCourseSpecifications() {
        await Csrf.getCookie();
        return Api.get('/student/current-course-specifications');
    },

    async getCourseSpecificationsBySessionAndSemester(session_id, semester_id) {
        await Csrf.getCookie();
        return Api.get('/student/course-specifications-by-session-and-semester/' + session_id + '/' + semester_id);
    },

    async getMyCurrentSemesterCourseSpecifications(session_id, level_id, programme_id, semester_id) {
        await Csrf.getCookie();
        return Api.get('/student/current-semester-course-specifications/' + session_id + '/' + level_id + '/' + programme_id + '/' + semester_id);
    },

    async getMyResults(data) {
        await Csrf.getCookie();
        return Api.patch('/students/student-results', data);
    },

    async downloadResults(student_id, session_id, programme_id) {
        return Api.get('/students/student-results/download/' + student_id + '/' + session_id + '/' + programme_id, { responseType: 'blob' });
    },

    async downloadStudentTranscript(student_id) {
        return Api.get('/students/download-transcript/' + student_id, { responseType: 'blob' });
        // return Api.get('/students/download-transcript/' + student_id);
    },

    async getCreditLoadLimitByProgramme(programme_id, level_id) {
        await Csrf.getCookie();
        return Api.get('/student/credit-load-limit-by-programme-and-level/' + programme_id + '/' + level_id);
    },

    async getAvailableHostels() {
        await Csrf.getCookie();
        return Api.get('/student/hostels/available');
    },

    async makeHostelReservation(hostel_block_allocation_id) {
        await Csrf.getCookie();
        return Api.post('/student/hostel/reservation/reserve/' + hostel_block_allocation_id);
    },

    async getMyHostelReservation() {
        await Csrf.getCookie();
        return Api.get('/student/hostel/my-reservation');
    },

    async getMyHostelAllocation() {
        await Csrf.getCookie();
        return Api.get('/student/hostel/my-allocation');
    },

    async releaceHostelReservation(reservation_id) {
        await Csrf.getCookie();
        return Api.post('/student/hostel/reservation/release/' + reservation_id);
    },

    async getBedSpacesInformation(institute_id, session_id = null) {
        await Csrf.getCookie();
        return Api.get('/bed-space/get-bedspaces-information?institute_id=' + institute_id + '&session_id=' + session_id);
    },

    async getStudentByMatricNumber(matric_number, institute_id = null) {
        await Csrf.getCookie();
        return Api.get('/get-student-by-matric-number/' + matric_number + '?institute_id=' + institute_id)
    },

    async getStudentByID(student_id) {
        await Csrf.getCookie();
        return Api.get('/get-single-student/' + student_id)
    },

    async getStudentByStudentID(student_id) {
        await Csrf.getCookie();
        return Api.get('/get-single-student-profile/' + student_id)
    },

    async getStudentRecord() {
        await Csrf.getCookie();
        return Api.get('/get-profile')
    },

    async getStudentCandidacyByID(student_id) {
        await Csrf.getCookie();
        return Api.get('/get-student-candidacy/' + student_id)
    },

    async getStudentCandidacyResultsByID(candidate_id) {
        await Csrf.getCookie();
        return Api.get('/get-student-candidacy-results/' + candidate_id)
    },

    async checkAccomodationPaymentStatus(student_id, session_id) {
        await Csrf.getCookie();
        return Api.get('/student-accomodation-payment-status/' + student_id + '/' + session_id);
    },

    async checkCoureRegistrationPaymentStatus(student_id, session_id) {
        await Csrf.getCookie();
        return Api.get('/student-course-registration-payment-status/' + student_id + '/' + session_id);
    },

    async downloadHostelFormSlip(url) {
        // await Csrf.getCookie();
        return Api.get(url, { responseType: 'blob' });
    },

    async searchStudents(search_string, institute_id) {
        await Csrf.getCookie();
        return Api.get('/students-search?search_string='+search_string + '&institute_id=' + institute_id)
    },

    //------------------ APIs for resetting biometrics -----------
    async resetSignature(student_id) {
        await Csrf.getCookie();
        return Api.patch('/signature/reset/' + student_id);
    },
    async resetProfilePicture(student_id) {
        await Csrf.getCookie();
        return Api.patch('/profile-picture/reset/' + student_id);
    },

    async checkRegistrationPaymentStatusBySession(student_id, session_id, semester_id) {
        await Csrf.getCookie();
        return Api.get('/get-registration-payment-status-by-session/' + student_id + '/' + session_id + "?semester_id=" + semester_id);
    },

    async getStudentsByProgrammeAndLevelID(programme_id, level_id) {
        await Csrf.getCookie();
        return Api.get('/all-programme-level-students/' + programme_id + '/' + level_id)
    },

    async MatricExemptionTemplateExport() {
        return Api.get('/matric-number-exemption/export/template', { responseType: 'blob' })
    },

    async searchStudentByQueryParams(institute_id, search_string) {
        await Csrf.getCookie();
        return Api.get('/invoice-search/' + institute_id + '?search_string='+search_string)
    },

    async templateExport(url) {
        return Api.get(url, { responseType: 'blob' })
    },

    async ExemptionTemplateExport(url) {
        return Api.get(url, { responseType: 'blob' })
    },

    async GraduatingStudentsListExport(url) {
        return Api.get(url, { responseType: 'blob' })
    },

    async fetchGraduationListByProgrammeAndSession(programme, entry_session, type, institute_id = null)
    {
        await Csrf.getCookie();
        return Api.get('/graduation-list/programme/' + programme +'/session/' + entry_session + '/type/' + type + "?institute_id=" + institute_id);
    },

    async exportQualifiedGraduatingStudents(programme, entry_session, institute_id = null)
    {
        return Api.get('/export-graduation-list/programme/' + programme +'/session/' + entry_session + "?institute_id=" + institute_id, { responseType: 'blob' });
    },

    async exportQualifiedGraduatingStudentsByPresentation(programme, entry_session, presentation, institute_id = null)
    {
        return Api.get('/export-graduation-list/programme/' + programme +'/session/' + entry_session + "/presentation/"  + presentation + "?institute_id=" + institute_id, { responseType: 'blob' });
    },

    async academicPerformanceComputationByCommand(data)
    {
        await Csrf.getCookie();
        return Api.post('/calculate-academic-performance', data);
    },

    async academicPerformanceComputationByLevelCommand(data)
    {
        await Csrf.getCookie();
        return Api.post('/calculate-academic-performance-by-level', data);
    },


    async fetchGraduatedStudents(programme, session)
    {
        await Csrf.getCookie();
        return Api.get('/graduated-students/programme/' + programme +'/graduation_session/' + session);
    },

    async getStudentCourseRegSubmissionListStats(params)
    {
        await Csrf.getCookie();
        return Api.get('/all-students-course-registration-submission-list-stats/institute');
    },

    async graduateStudents(programme, session, data)
    {
        await Csrf.getCookie();
        return Api.post('/graduate-students/programme/' + programme +'/session/' + session, data);
    },

    async updateStudentSpecialization(student_id, specification_id) {
        await Csrf.getCookie();
        return Api.patch('/update-student-specialization/' + student_id + '/' + specification_id);
    },

    async queueExportStudentsCourseRegistrationSubmission(formData){
        await Csrf.getCookie();
        return Api.post('/all-students-course-registration-submission-list/institute/exportQueue', formData);
    },

    async queueExportStudentsRegistration(formData){
        await Csrf.getCookie();
        return Api.post('/all-students-registration/institute/exportQueue', formData);
    },

};


